import { IngredienteSezioneAggiuntiva } from "./IngredienteSezioneAggiuntiva";

type TipologiaScelta = "singola" | "multipla";


export const SezioneAggiuntivaConverter = {
    toFirestore(sezioneAggiuntiva: SezioneAggiuntiva): firebase.firestore.DocumentData {
        return {};
    },
    fromFirestore(
        snapshot: firebase.firestore.QueryDocumentSnapshot,
        options: firebase.firestore.SnapshotOptions
    ): SezioneAggiuntiva {
        const data = snapshot.data(options)!;
        let sezioneAggiuntiva = new SezioneAggiuntiva();
        sezioneAggiuntiva.id = snapshot.id;
        sezioneAggiuntiva.titolo = data.titolo;
        sezioneAggiuntiva.descrizione = data.descrizione;
        sezioneAggiuntiva.obbligatorio = data.obbligatorio;
        sezioneAggiuntiva.tipologiaScelta = data.tipologia_scelta;
        sezioneAggiuntiva.ingredienteSezioneAggiuntivaList = data.ingrediente_sezione_aggiuntiva_list;
        return sezioneAggiuntiva;
    }
};

export class SezioneAggiuntiva {
    private _id: string;
    private _titolo: string;
    private _descrizione: string;
    private _obbligatorio: boolean;
    private _tipologiaScelta: TipologiaScelta;
    private _ingredienteSezioneAggiuntivaList: IngredienteSezioneAggiuntiva[];

    constructor() {
        this._id = "";
        this._titolo = "";
        this._descrizione = "";
        this._obbligatorio = false;
        this._tipologiaScelta = "singola";
        this._ingredienteSezioneAggiuntivaList = [];
    }

    convertToFirestore(): any {
        return {
            titolo: this._titolo,
            descrizione: this._descrizione,
            obbligatorio: this.obbligatorio,
            tipologia_scelta: this._tipologiaScelta,
            ingrediente_sezione_aggiuntiva_list: []
        }
    }

    static async convertFromFirestore(data: any) {
        let sezioneAggiuntiva = new SezioneAggiuntiva();
        sezioneAggiuntiva.titolo = data.titolo;
        sezioneAggiuntiva.descrizione = data.descrizione;
        sezioneAggiuntiva.obbligatorio = data.obbligatorio;
        sezioneAggiuntiva.tipologiaScelta = data.tipologia_scelta;
        for (let ingrediente_sezione_aggiuntiva of data.ingrediente_sezione_aggiuntiva_list) {
            let ingredienteSezioneAggiuntivaConverted = await IngredienteSezioneAggiuntiva.convertFromFirestore(ingrediente_sezione_aggiuntiva);
            sezioneAggiuntiva.ingredienteSezioneAggiuntivaList.push(ingredienteSezioneAggiuntivaConverted);
        }
        return sezioneAggiuntiva;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get titolo(): string {
        return this._titolo;
    }

    set titolo(value: string) {
        this._titolo = value;
    }

    get descrizione(): string {
        return this._descrizione;
    }

    set descrizione(value: string) {
        this._descrizione = value;
    }

    get obbligatorio(): boolean {
        return this._obbligatorio;
    }

    set obbligatorio(value: boolean) {
        this._obbligatorio = value;
    }

    get tipologiaScelta(): TipologiaScelta {
        return this._tipologiaScelta;
    }

    set tipologiaScelta(value: TipologiaScelta) {
        this._tipologiaScelta = value;
    }

    get ingredienteSezioneAggiuntivaList(): IngredienteSezioneAggiuntiva[] {
        return this._ingredienteSezioneAggiuntivaList;
    }

    set ingredienteSezioneAggiuntivaList(value: IngredienteSezioneAggiuntiva[]) {
        this._ingredienteSezioneAggiuntivaList = value;
    }
}